<template>
  <div style="width: 100%;height:150px;">
    <el-amap
      v-if="showMap"
      class="amap-box"
      ref="amap"
      :center="center"
      :zoom="zoom"
      >
      <el-amap-marker
        :position="[pointInfo.reportAddressLong, pointInfo.reportAddressLat]"
        :offset="[-40, -36]"
      >
        <div style="text-align: center;margin-top:8px;">
          <img
            style="width:23px;height:28px;"
            src="@/assets/image/add.png"
            alt=""
          />
        </div>
      </el-amap-marker>
    </el-amap>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
Vue.use(VueAMap);

export default {
  name: "AMap",
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    index: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      showMap: false,
      amap: null,
      mapApiKey: "f6a6784aeb8609f7920f60ba3161ae54", //您申请的key值
      zoom: 17,
      center: [114.039587, 22.699961],
    };
  },
  created() {
    this.showMap = false;
  },
  mounted() {
    if (this.pointInfo.reportAddressLong) {
      this.center = [this.pointInfo.reportAddressLong, this.pointInfo.reportAddressLat]
    }
    this.$nextTick(() => {
      this.showMap = true;
      this.init();
    });
  },
  beforeDestroy() {
    this.showMap = false;
    this.amap = null;
  },
  methods: {
    // 初始化地图
    init() {
      let _self = this;
      VueAMap.initAMapApiLoader({
        key: _self.mapApiKey,
        plugin: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.ToolBar",
          "AMap.MapType",
          "AMap.PolyEditor",
          "AMap.CircleEditor",
          "AMap.Geocoder",
          "AMap.Boundary",
          "AMap.DistrictSearch",
          "AMap.Geolocation",
          "AMap.Heatmap"
        ],
        // 高德 sdk 版本
        v: "1.4.15"
      });
    },
  },
  watch: {
    pointInfo: {
      deep: true,
      handler(val) {
        if (val.reportAddressLong) {
          this.center = [val.reportAddressLong, val.reportAddressLat]
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.amap-box {
  width: 100%;
  min-height: 178px;
}
/deep/.amap-logo {
  right: 0 !important;
  left: auto !important;
  display: none !important;
}

/deep/.amap-copyright {
  right: 70px !important;
  left: auto !important;
  opacity: 0 !important;
}

/deep/ .el-dialog__header {
  border-bottom: 0 !important;
}
.point {
  width: 300px;
  padding: 10px 24px;
  background: #fff;
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: #494c4f;
  box-shadow: 0px 2px 4px 0px rgba(22, 54, 79, 0.08);
  border-radius: 33px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mCheckInManage/dwdlClockList/map.vue